import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import { defineComponent, ref, reactive, watch, onMounted, onUnmounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { showErrorMessage } from '@/api/index';
import { userApi } from '@/api/modules';

// 在Dashboard.vue中获取用户手机号的示例代码

// 方法2：从Vuex store获取
// const store = useStore();
// const userInfo = store.getters.userInfo;
// const phoneFromStore = userInfo.phone;

// 使用示例
// console.log('用户手机号(Vuex):', phoneFromStore);

export default defineComponent({
  name: 'MainLayout',
  components: {
    // MenuUnfoldOutlined,
    // MenuFoldOutlined,
    // BellOutlined,
    // DownOutlined,
    // CopyOutlined
  },
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var store = useStore();
    var userPhone = localStorage.getItem('userPhone');

    // 从 store 获取用户信息
    var userInfo = computed(function () {
      var info = store.getters.userInfo;
      console.log('Layout userInfo:', info);
      return info;
    });
    var selectedKeys = ref(['dashboard']);
    var activeMenuKey = ref('dashboard');
    var sidebarCollapsed = ref(false);
    var hoveredMenu = ref(null);
    var hoveredSubmenu = ref(null);
    var tooltipTimer = ref(null);

    // 菜单数据
    var menuItems = reactive([{
      key: 'dashboard',
      title: '矩阵概况',
      bannerTitle: '矩阵概况',
      icon: require('@/assets/home.png'),
      selectIcon: require('@/assets/home_w.png'),
      expanded: false
    }, {
      key: 'traffic-overview',
      title: '矩阵流量',
      bannerTitle: '矩阵流量',
      icon: require('@/assets/ju_liu.png'),
      selectIcon: require('@/assets/ju_liu_w.png'),
      expanded: false,
      children: [{
        key: 'internet-traffic',
        title: '流量概况',
        bannerTitle: '流量概况'
      }, {
        key: 'traffic-details',
        title: '流量明细',
        bannerTitle: '流量明细'
      }]
    }, {
      key: 'article',
      title: '生成文章',
      icon: require('@/assets/article_black.png'),
      selectIcon: require('@/assets/article_w.png'),
      expanded: false,
      children: [{
        key: 'article-word',
        title: '关键字',
        bannerTitle: '关键字生成规则'
      }, {
        key: 'article-title',
        title: '标题',
        bannerTitle: '标题'
      }, {
        key: 'article-rule',
        title: '内容生成规则',
        bannerTitle: '内容生成规则'
      }, {
        key: 'article-task',
        title: '创建生成任务',
        bannerTitle: '创建生成任务'
      }, {
        key: 'article-recommend',
        title: '个性化单篇文章',
        bannerTitle: '个性化单篇文章'
      }]
    }, {
      key: 'draft',
      title: '草稿箱',
      bannerTitle: '草稿箱',
      icon: require('@/assets/draft.png'),
      selectIcon: require('@/assets/draft_w.png'),
      expanded: false
    }, {
      key: 'publish',
      title: '自动发布任务',
      bannerTitle: '自动发布任务',
      selectIcon: require('@/assets/push_w.png'),
      icon: require('@/assets/push.png'),
      expanded: false
    }, {
      key: 'all-articles',
      title: '所有文章(含草稿箱)',
      bannerTitle: '所有文章(含草稿箱)',
      icon: require('@/assets/data.png'),
      selectIcon: require('@/assets/data_w.png'),
      expanded: false
    }, {
      key: 'platform',
      title: '内容平台管理',
      bannerTitle: '内容平台管理',
      icon: require('@/assets/collect.png'),
      selectIcon: require('@/assets/collect_w.png'),
      expanded: false,
      children: [{
        key: 'platform-media',
        title: '内容媒体平台',
        bannerTitle: '内容媒体平台'
      }, {
        key: 'platform-create',
        title: '自建站平台',
        bannerTitle: '自建站平台'
      }]
    }, {
      key: 'materia-library',
      title: '素材库',
      bannerTitle: '素材库',
      icon: require('@/assets/materia.png'),
      selectIcon: require('@/assets/materia.png'),
      expanded: false
    }, {
      key: 'knowledge-base',
      title: '知识库',
      bannerTitle: '知识库',
      selectIcon: require('@/assets/knowledge.png'),
      icon: require('@/assets/knowledge.png'),
      expanded: false
    }, {
      key: 'account-management',
      title: '账号管理',
      bannerTitle: '账号管理',
      icon: require('@/assets/account.png'),
      selectIcon: require('@/assets/account_w.png'),
      expanded: false
    }, {
      key: 'account-recharge',
      title: '账户充值/算力充值',
      bannerTitle: '账户充值/算力充值',
      selectIcon: require('@/assets/account_r_w.png'),
      icon: require('@/assets/account_r.png'),
      expanded: false
    }]);

    // 处理菜单点击
    var handleMenuClick = function handleMenuClick(menu) {
      if (menu.children) {
        // 切换展开状态
        menu.expanded = !menu.expanded;
        // 设置当前活动菜单
        // activeMenuKey.value = menu.key
      }
      // else {
      //   // 导航到对应路由
      //   selectedKeys.value = [menu.key]
      //   activeMenuKey.value = menu.key
      //   router.push({ name: menu.key })
      // }
    };

    // 处理菜单点击
    var handleMenuClickCatch = function handleMenuClickCatch(menu) {
      // 如果点击的不是当前活动菜单，先收起之前有二级菜单的菜单
      if (activeMenuKey.value !== menu.key) {
        var previousActiveMenu = menuItems.find(function (item) {
          return item.key === activeMenuKey.value;
        });
        if (previousActiveMenu && previousActiveMenu.children) {
          previousActiveMenu.expanded = false;
        }
      }
      if (menu.children) {
        // 切换展开状态
        menu.expanded = !menu.expanded;
        // 设置当前活动菜单
        activeMenuKey.value = menu.key;
      } else {
        // 导航到对应路由
        selectedKeys.value = [menu.key];
        activeMenuKey.value = menu.key;
        router.push({
          name: menu.key
        });
      }
    };

    // 处理子菜单点击
    var handleSubmenuClick = function handleSubmenuClick(parentMenu, submenu) {
      selectedKeys.value = [submenu.key];
      activeMenuKey.value = parentMenu.key;
      router.push({
        name: submenu.key
      });
    };

    // 统一的菜单状态设置函数
    var setMenuState = function setMenuState(routeName) {
      if (!routeName) {
        // 默认选中矩阵概况
        selectedKeys.value = ['dashboard'];
        activeMenuKey.value = 'dashboard';
        router.push({
          name: 'dashboard'
        });
        return;
      }
      selectedKeys.value = [routeName];
      var foundActiveMenu = false;

      // 首先尝试精确匹配菜单项
      menuItems.forEach(function (menu) {
        if (menu.key === routeName) {
          activeMenuKey.value = menu.key;
          foundActiveMenu = true;
          return;
        }
        if (menu.children) {
          var hasActiveChild = menu.children.some(function (child) {
            return child.key === routeName;
          });
          if (hasActiveChild) {
            menu.expanded = true;
            activeMenuKey.value = menu.key;
            foundActiveMenu = true;
            return;
          }
        }
      });

      // 如果精确匹配失败，再检查是否是子路由（如platform-create-add, platform-create-detail）
      if (!foundActiveMenu && routeName.includes('-')) {
        var routeParts = routeName.split('-');
        // 处理特殊情况，如platform-create-add应该匹配platform菜单
        if (routeParts.length >= 2) {
          var parentRoute = routeParts[0]; // 例如 'platform'

          menuItems.forEach(function (menu) {
            // 检查菜单key是否匹配路由的第一部分，但要排除已经精确匹配的情况
            if (menu.key.startsWith(parentRoute) && menu.key !== routeName) {
              // 检查是否是真正的父子关系，而不是同级的相似命名
              var menuParts = menu.key.split('-');
              if (menuParts.length === 1 || menuParts.length > 1 && routeName.startsWith(menu.key + '-')) {
                menu.expanded = true;
                activeMenuKey.value = menu.key;
                foundActiveMenu = true;

                // 如果有子菜单，检查是否有匹配的子菜单
                if (menu.children) {
                  var childMatched = false;
                  menu.children.forEach(function (child) {
                    console.log("\u68C0\u67E5\u5B50\u83DC\u5355: ".concat(child.key, ", \u5F53\u524D\u8DEF\u7531: ").concat(routeName));
                    // 如果子菜单的key与当前路由匹配
                    if (child.key === routeName) {
                      console.log("\u7CBE\u786E\u5339\u914D: ".concat(child.key, " === ").concat(routeName));
                      selectedKeys.value = [child.key];
                      childMatched = true;
                    }
                    // 如果当前路由是子菜单的扩展路由（如platform-create-add是platform-create的扩展）
                    else if (routeName.startsWith(child.key + '-')) {
                      console.log("\u6269\u5C55\u8DEF\u7531\u5339\u914D: ".concat(routeName, " \u4EE5 ").concat(child.key + '-', " \u5F00\u5934"));
                      selectedKeys.value = [child.key];
                      childMatched = true;
                    }
                  });

                  // 如果没有匹配到子菜单，但路由确实属于这个菜单组，保持父菜单选中
                  if (!childMatched) {
                    selectedKeys.value = [menu.key];
                  }
                }
              }
            }
          });
        }
      }
      console.log('setMenuState - activeMenuKey:', activeMenuKey.value, 'selectedKeys:', selectedKeys.value, 'route:', routeName);
    };

    // 根据当前路由设置选中的菜单
    watch(function () {
      return route.name;
    }, function (name) {
      setMenuState(name);
    }, {
      immediate: true
    });

    // 顶部通知横幅控制
    var showHeaderNotice = ref(true);
    var hideHeaderNotice = function hideHeaderNotice() {
      showHeaderNotice.value = false;
    };

    // 初始化时设置广告显示状态
    onMounted(function () {
      // 添加调试日志，检查通知横幅状态
      console.log('通知横幅显示状态:', showHeaderNotice.value);
      showHeaderNotice.value = true;

      // 延迟检查确保元素可见性，防止被广告拦截器隐藏
      setTimeout(function () {
        var noticeElement = document.querySelector('.header-notice-banner');
        if (noticeElement && showHeaderNotice.value) {
          noticeElement.style.display = 'flex';
          noticeElement.style.visibility = 'visible';
          noticeElement.style.opacity = '1';
        }
      }, 100);
    });

    // 组件销毁时清理定时器
    onUnmounted(function () {
      if (tooltipTimer.value) {
        clearTimeout(tooltipTimer.value);
      }
    });
    var collapsed = ref(false);
    var toggleCollapsed = function toggleCollapsed() {
      collapsed.value = !collapsed.value;
    };
    var navigateTo = function navigateTo(path) {
      router.push(path);
    };
    var copyText = function copyText(text) {
      navigator.clipboard.writeText(text).then(function () {
        _message.success('复制成功');
      })["catch"](function () {
        showErrorMessage('复制失败');
      });
    };
    var handleLogout = function handleLogout() {
      userApi.logout().then(function (res) {
        if (res.success) {
          // 清除token和用户信息;
          store.dispatch('logout').then(function () {
            // 跳转到登录页
            router.push({
              name: 'login'
            });
          });
        } else {
          showErrorMessage(res.message);
        }
      });
    };
    var navigateToMedia = function navigateToMedia() {
      router.push({
        name: 'platform-media'
      });
    };

    // 通知相关状态
    var showNotificationDropdown = ref(false);
    var activeNotificationTab = ref('unread');

    // 通知数据
    var notifications = reactive([{
      id: 1,
      title: '测试体系构建方法论',
      time: '2025年6月1日 08:08:08',
      unread: true
    }, {
      id: 2,
      title: '系统维护通知',
      time: '2025年5月31日 15:30:22',
      unread: true
    }, {
      id: 3,
      title: '新功能上线公告',
      time: '2025年5月31日 10:15:45',
      unread: false
    }, {
      id: 4,
      title: '安全更新提醒',
      time: '2025年5月30日 18:20:10',
      unread: false
    }, {
      id: 5,
      title: '618营销活动即将开始',
      time: '2025年5月30日 09:45:30',
      unread: false
    }, {
      id: 6,
      title: '数据备份完成通知',
      time: '2025年5月29日 22:15:45',
      unread: false
    }, {
      id: 7,
      title: '用户权限更新提醒',
      time: '2025年5月29日 16:30:12',
      unread: false
    }, {
      id: 8,
      title: '服务器性能优化完成',
      time: '2025年5月28日 14:45:33',
      unread: false
    }, {
      id: 9,
      title: '新版本发布预告',
      time: '2025年5月28日 11:20:18',
      unread: false
    }, {
      id: 10,
      title: '系统日志清理通知',
      time: '2025年5月27日 09:30:25',
      unread: false
    }]);

    // 根据当前标签过滤通知
    var filteredNotifications = computed(function () {
      if (activeNotificationTab.value === 'unread') {
        return notifications.filter(function (item) {
          return item.unread;
        });
      }
      return notifications;
    });

    // 切换通知下拉菜单
    var toggleNotificationDropdown = function toggleNotificationDropdown() {
      showNotificationDropdown.value = !showNotificationDropdown.value;
    };

    // 处理通知下拉菜单可见性变化
    var handleNotificationVisibleChange = function handleNotificationVisibleChange(visible) {
      showNotificationDropdown.value = visible;
    };

    // 标记所有通知为已读
    var markAllAsRead = function markAllAsRead() {
      notifications.forEach(function (item) {
        item.unread = false;
      });
      _message.success('已标记所有通知为已读');
    };

    // 查看全部通知
    var viewAllNotifications = function viewAllNotifications() {
      // 跳转到通知信页面
      router.push({
        name: 'notice-sign'
      });
      showNotificationDropdown.value = false;
    };

    // 处理通知点击
    var handleNotificationClick = function handleNotificationClick(item) {
      // 标记通知为已读
      item.unread = false;

      // 跳转到通知信页面并传递通知信息
      router.push({
        name: 'notice-sign',
        query: {
          showDetail: 'true',
          id: item.id,
          title: item.title,
          time: item.time,
          unread: item.unread
        }
      });

      // 关闭通知下拉菜单
      showNotificationDropdown.value = false;
    };

    // 切换侧边栏收缩状态
    var toggleSidebar = function toggleSidebar() {
      sidebarCollapsed.value = !sidebarCollapsed.value;
    };

    // 处理菜单hover
    var handleMenuHover = function handleMenuHover(menu) {
      if (sidebarCollapsed.value) {
        // 清除之前的定时器
        if (tooltipTimer.value) {
          clearTimeout(tooltipTimer.value);
          tooltipTimer.value = null;
        }
        hoveredMenu.value = menu.key;
      }
    };

    // 处理菜单离开hover
    var handleMenuLeave = function handleMenuLeave() {
      if (sidebarCollapsed.value) {
        // 延迟隐藏tooltip，给用户时间移动到子菜单
        tooltipTimer.value = setTimeout(function () {
          hoveredMenu.value = null;
          hoveredSubmenu.value = null;
        }, 150); // 150ms延迟
      }
    };

    // 处理tooltip区域的hover
    var handleTooltipEnter = function handleTooltipEnter() {
      if (tooltipTimer.value) {
        clearTimeout(tooltipTimer.value);
        tooltipTimer.value = null;
      }
    };

    // 处理tooltip区域的leave
    var handleTooltipLeave = function handleTooltipLeave() {
      if (sidebarCollapsed.value) {
        hoveredMenu.value = null;
        hoveredSubmenu.value = null;
      }
    };

    // 处理子菜单tooltip点击
    var handleSubmenuTooltipClick = function handleSubmenuTooltipClick(parentMenu, submenu) {
      selectedKeys.value = [submenu.key];
      activeMenuKey.value = parentMenu.key;
      hoveredMenu.value = null;
      hoveredSubmenu.value = null;
      router.push({
        name: submenu.key
      });
    };
    var currentMenuTitle = computed(function () {
      // 查找当前选中的菜单
      var menu = menuItems.find(function (menu) {
        return menu.key === activeMenuKey.value;
      });
      // 如果找到菜单
      if (menu) {
        // 如果是有子菜单的父菜单，且有选中的子菜单
        if (menu.children && selectedKeys.value.length > 0) {
          // 查找选中的子菜单
          var selectedChild = menu.children.find(function (child) {
            return child.key === selectedKeys.value[0];
          });
          if (selectedChild) {
            // 如果找到选中的子菜单，返回子菜单标题
            return selectedChild.bannerTitle;
          }
        }
        // 否则返回父菜单标题
        return menu.bannerTitle;
      }

      // 如果没有找到菜单，返回空字符串
      return '';
    });
    return {
      activeMenuKey: activeMenuKey,
      selectedKeys: selectedKeys,
      userPhone: userPhone,
      sidebarCollapsed: sidebarCollapsed,
      hoveredMenu: hoveredMenu,
      hoveredSubmenu: hoveredSubmenu,
      tooltipTimer: tooltipTimer,
      // openKeys,
      menuItems: menuItems,
      handleMenuClick: handleMenuClick,
      handleMenuClickCatch: handleMenuClickCatch,
      handleSubmenuClick: handleSubmenuClick,
      handleSubmenuTooltipClick: handleSubmenuTooltipClick,
      handleMenuHover: handleMenuHover,
      handleMenuLeave: handleMenuLeave,
      handleTooltipEnter: handleTooltipEnter,
      handleTooltipLeave: handleTooltipLeave,
      collapsed: collapsed,
      toggleCollapsed: toggleCollapsed,
      toggleSidebar: toggleSidebar,
      navigateTo: navigateTo,
      copyText: copyText,
      handleLogout: handleLogout,
      userInfo: userInfo,
      showHeaderNotice: showHeaderNotice,
      hideHeaderNotice: hideHeaderNotice,
      navigateToMedia: navigateToMedia,
      currentMenuTitle: currentMenuTitle,
      showNotificationDropdown: showNotificationDropdown,
      activeNotificationTab: activeNotificationTab,
      filteredNotifications: filteredNotifications,
      toggleNotificationDropdown: toggleNotificationDropdown,
      handleNotificationVisibleChange: handleNotificationVisibleChange,
      markAllAsRead: markAllAsRead,
      viewAllNotifications: viewAllNotifications,
      handleNotificationClick: handleNotificationClick
    };
  }
});